import axios from "axios";
import { getTokenFromLocalStorage } from "./common";
import config from "./config";

const api = axios.create({
  baseURL:
    config.baseUrl === undefined || config.baseUrl === ""
      ? "https://" + window.location.hostname
      : config.baseUrl,
});

const inFlightGets = new Map();

const getRequestKey = (requestConfig) =>
  JSON.stringify([
    Object.keys(requestConfig.params || {})
      .sort()
      .map((key) => [key, requestConfig.params[key]]),
    requestConfig.responseType || "",
    requestConfig.timeout || "",
    requestConfig.withCredentials || false,
    requestConfig.headers || {},
  ]);

const originalGet = api.get.bind(api);

api.get = (url, requestConfig = {}) => {
  if (requestConfig.signal) return originalGet(url, requestConfig);

  const key = getRequestKey(requestConfig);
  const current = inFlightGets.get(url);

  if (current?.key === key) return current.promise;

  const entry = { key, promise: originalGet(url, requestConfig) };
  inFlightGets.set(url, entry);

  const release = () => {
    if (inFlightGets.get(url) === entry) inFlightGets.delete(url);
  };
  entry.promise.then(release, release);

  return entry.promise;
};

api.interceptors.request.use((request) => {
  request.metadata = { started: performance.now() };
  request.headers.Authorization = getTokenFromLocalStorage();

  return request;
});

api.interceptors.response.use(
  (response) => {
    response.config.metadata.ended = performance.now();
    response.duration = Math.ceil(
      response.config.metadata.ended - response.config.metadata.started
    );
    return response;
  },
  (error) => {
    if (error.config?.metadata) {
      error.config.metadata.ended = performance.now();
      error.duration = Math.ceil(
        error.config.metadata.ended - error.config.metadata.started
      );
    }
    if (axios.isCancel(error)) error.canceled = true;
    return Promise.reject(error);
  }
);

export default api;
